<template>
  <v-card
    v-bind="$attrs"
    v-on="$listeners"
    :class="defaultClass"
  >
    <slot name="default"> </slot>
    <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
      <slot :name="slot" v-bind="scope" />
    </template>
  </v-card>
</template>

<script>
export default {
  props: {
    defaultPanel: { // 디폴트 패딩 + 디폴트 라운딩
      type: Boolean,
      default: false,
    },
    defaultRounded: { // 디폴트 라운딩
      type: Boolean,
      default: false,
    },
  },
  computed: {
    breakpointPadding() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
        case "sm":
        case "md":
        case "lg":
          return "pa-4";
        case "xl":
        default:
          return "pa-6";
      }
    },
    breakpoingRounded() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
        case "sm":
          return "rounded-0";
        case "md":
        case "lg":
        case "xl":
        default:
          return "rounded-lg";
      }
    },
    defaultClass() {
      if (this.defaultPanel) {
        return `${this.breakpointPadding} ${this.breakpoingRounded}`;
      } else if (this.defaultRounded) {
        return `${this.breakpoingRounded}`;
      } else {
        return "";
      }
    },
  },
};
</script>

<style></style>
